// Global console override for production
class ConsoleManager {
  constructor() {
    this.isDebugMode = this.checkDebugMode();
    this.originalConsole = {
      log: console.log,
      warn: console.warn,
      error: console.error,
      info: console.info
    };
    
    this.setupConsoleOverride();
  }

  checkDebugMode() {
    // Check URL parameter first
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('debug') === 'true') {
      localStorage.setItem('debug_mode', 'true');
      return true;
    }
    if (urlParams.get('debug') === 'false') {
      localStorage.removeItem('debug_mode');
      return false;
    }
    
    // Check localStorage
    return localStorage.getItem('debug_mode') === 'true';
  }

  setupConsoleOverride() {
    if (!this.isDebugMode) {
      // Override console methods to suppress output
      console.log = () => {};
      console.warn = () => {};
      console.info = () => {};
      // Keep console.error for critical errors
      
      // Also suppress React warnings in production
      const originalError = console.error;
      console.error = (...args) => {
        const message = args[0];
        if (typeof message === 'string' && (
          message.includes('Warning: Maximum update depth exceeded') ||
          message.includes('Download the React DevTools')
        )) {
          return; // Suppress these specific warnings
        }
        originalError.apply(console, args);
      };
    }
  }

  enableDebug() {
    this.isDebugMode = true;
    localStorage.setItem('debug_mode', 'true');
    this.restoreConsole();
    console.log('🐛 Debug mode enabled');
  }

  disableDebug() {
    this.isDebugMode = false;
    localStorage.removeItem('debug_mode');
    this.setupConsoleOverride();
    console.log('🔇 Debug mode disabled');
  }

  restoreConsole() {
    console.log = this.originalConsole.log;
    console.warn = this.originalConsole.warn;
    console.error = this.originalConsole.error;
    console.info = this.originalConsole.info;
  }

  toggle() {
    if (this.isDebugMode) {
      this.disableDebug();
    } else {
      this.enableDebug();
    }
  }

  isEnabled() {
    return this.isDebugMode;
  }
}

// Create singleton instance
const consoleManager = new ConsoleManager();

// Make it available globally
window.consoleManager = consoleManager;

// Add keyboard shortcut (Ctrl+Shift+D)
document.addEventListener('keydown', (e) => {
  if (e.ctrlKey && e.shiftKey && e.key === 'D') {
    e.preventDefault();
    consoleManager.toggle();
  }
});

export default consoleManager;
